// extracted by mini-css-extract-plugin
export default {"option":"onboarding-select_option__TD1CB","check":"onboarding-select_check__H3Gos","selected":"onboarding-select_selected__mMblj"};